// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

function updateVariantDisplay(selectedVariantId) {
    const variants = document.querySelectorAll('[data-variant-id]');

    variants.forEach(variant => {
        const variantId = variant.getAttribute('data-variant-id');

        if (variantId === selectedVariantId) {
            variant.style.display = 'block'; // Show the matching variant
        } else {
            variant.style.display = 'none';  // Hide all others
        }
    });
}

// Run when the page loads
document.addEventListener("DOMContentLoaded", function () {
    const currentVariantElement = document.querySelector('[name="id"]'); // Default Shopify variant input
    if (currentVariantElement) {
        const selectedVariantId = currentVariantElement.value;
        updateVariantDisplay(selectedVariantId);
    }
});

// Run when the variant changes
document.addEventListener("product:variant-change", function (evt) {
    console.log("Product variant changed");
    console.log(evt.detail.variant);
    console.log(evt.detail.variant.id);

    const selectedVariantId = String(evt.detail.variant.id); // Ensure it's a string for comparison
    updateVariantDisplay(selectedVariantId);
});


// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
